import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-download-excel-error-modal',
  templateUrl: './download-excel-error-modal.component.html',
  styleUrls: ['./download-excel-error-modal.component.scss'],
})
export class DownloadExcelErrorModalComponent implements OnInit {
  dataRecieved: any;

  constructor(
    public readonly dialogRef: MatDialogRef<DownloadExcelErrorModalComponent>,
    private readonly renderer: Renderer2,
    @Inject(MAT_DIALOG_DATA) data
  ) {
    this.dataRecieved = data;
  }

  ngOnInit(): void {
    this.openedStart();
  }

  ngOnDestroy(): void {
    this.closedStart();
  }

  closeDialog() {
    this.dialogRef.close();
  }

  openedStart() {
    this.renderer.addClass(document.body, 'modal-open');
  }

  closedStart() {
    this.renderer.removeClass(document.body, 'modal-open');
  }
} 